<header class="top-header">
  <div class="header-container">
    <a class="logo-title-container" href="https://www.surreycc.gov.uk/" aria-label="Surrey County Council home">
      <img 
        src="https://www.surreycc.gov.uk/__data/assets/image/0012/14601/scc-logo-white.png" 
        alt="Surrey County Council Logo"
        title="Surrey County Council homepage"
        class="home-logo" />
    </a>
  </div>
</header>
<div class="home-bar">
  <div class="home-bar-inner">
<a href="https://www.surreycc.gov.uk/">Home</a>
  </div>
  
</div>

